export default __webpack_public_path__ + "static/media/product-image-15.f89a9d69.jpg";